import { Star } from "lucide-react";

const items = [
  "Matrículas Abertas",
  "Berçário ao Pré 2",
  "Manhã · Tarde · Integral",
  "Inglês · Música · Ballet",
  "Acolhimento & Segurança",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="py-6 bg-ink overflow-hidden select-none" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center font-display font-600 text-3xl md:text-4xl text-white/90 px-8">
            {t}
            <Star className="ml-8 h-6 w-6 text-brand-yellow fill-brand-yellow" strokeWidth={0} />
          </span>
        ))}
      </div>
    </section>
  );
}
